import { BlockScrollStrategy, Overlay, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, Inject, ApplicationRef, TemplateRef, AfterContentInit, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '../CustomDialog/DialogService';
import { BW_DIALOG_DATA } from '../CustomDialog/DialogToken';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

@Component({
	selector: 'app-user-feedback-dialog',
	templateUrl: './user-feedback-dialog.component.html',
	styleUrls: ['./user-feedback-dialog.component.scss']	
})
export class UserFeedbackDialogComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit
{	

	public title : string;
	public content : string;	

	public dialogData$ : BehaviorSubject<any> = new BehaviorSubject<any>(null);
	public dialogShown$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public dataContext : any = { $implicit : null };
	

	private dataSub : Subscription;
	private visibilitySub : Subscription;

	@Input() 
		get shown()
		{
			return this.dialogShown$.getValue();
		}

		set shown(value)
		{
			this.dialogShown$.next(value);
		}
	
	@Input()
	get dialogData() {
		return this.dialogData$.getValue();
	}

	set dialogData(value : any) {		
		this.dialogData$.next(value);
	}	

	private acceptClickedCallback : (event : any) => void;
	private cancelClickedCallback : (event : any) => void;

	@Output() acceptClicked : EventEmitter<any> = new EventEmitter<any>();
	@Output() cancelClicked : EventEmitter<any> = new EventEmitter<any>();	

	constructor()
	{

	}

	ngOnInit(): void 
	{		
		this.dataSub = this.dialogData$.subscribe({
			next : (newValue) => {
				if(newValue)
				{
					this.dataContext = { $implicit : newValue?.data }					
					this.acceptClickedCallback = newValue?.data?.acceptClicked;
					this.cancelClickedCallback = newValue?.data?.cancelClicked;					
				}
			}
		});		
	}

	ngOnDestroy(): void 
	{
		this.dataSub && this.dataSub?.unsubscribe();
		this.visibilitySub && this.visibilitySub?.unsubscribe();
	}

	ngAfterViewInit(): void 
	{	
		
	}

	ngAfterContentInit(): void {		
	}

	onAcceptClicked = (event : any) => 
	{		
		this.hide();
		"function" === typeof(this.acceptClickedCallback) && this.acceptClickedCallback(event);
	}

	onCancelClicked = (event : any) => 
	{		
		this.hide();
		"function" === typeof(this.cancelClickedCallback) && this.cancelClickedCallback(event);
	}

	hide = () => 
	{
		this.shown = false;		
	}

	show = () => {
		this.shown = true;
	}
}
